/**
 * A validation rule that ensures the input’s value is 9 digits
 */
const phone = function (node) {
  const regex = /^\d{3}[\s\-]*?\d{3}[\s\-]*?\d{3}$/
  return regex.test(node.value)
}

// override default rule behaviors for your custom rule
phone.blocking = true
phone.skipEmpty = true
phone.debounce = 20 // milliseconds
phone.force = true

export default phone
